/**
 * Página "hello" da fundação: uma série do banco em um gráfico, com filtros na URL.
 * Valida a cadeia completa (login → API → cache → motor de gráficos → Highcharts).
 */
import { Alert, Group, Loader, Stack, Text, TextInput, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';

import { ErroApi, apiGet, type Envelope } from '../api/cliente';
import { Grafico, type GraficoApi } from '../components/Grafico';
import { useFiltrosUrl } from '../lib/url-state';

const PADROES = { codigo: 'br_ibovespa', inicio: '2024-01-01' };

export function Demo() {
  const [filtros, definir] = useFiltrosUrl(PADROES);
  const consulta = useQuery({
    queryKey: ['demo.serie', filtros],
    queryFn: ({ signal }) =>
      apiGet<Envelope<{ grafico: GraficoApi }>>('/demo/serie', filtros, signal),
  });

  return (
    <Stack>
      <Title order={3}>Demonstração · série do banco</Title>
      <Group align="end">
        <TextInput
          label="Código"
          defaultValue={filtros.codigo}
          onBlur={(e) => definir({ codigo: e.currentTarget.value.trim() })}
        />
        <TextInput
          label="Início"
          type="date"
          value={filtros.inicio}
          onChange={(e) => definir({ inicio: e.currentTarget.value })}
        />
      </Group>
      {consulta.isPending && <Loader />}
      {consulta.isError && (
        <Alert color="red">
          {consulta.error instanceof ErroApi ? consulta.error.message : 'Erro inesperado.'}
        </Alert>
      )}
      {consulta.data && (
        <>
          <Grafico grafico={consulta.data.data.grafico} />
          <Text size="xs" c="dimmed">
            Dados até {consulta.data.meta.dados_ate} · cache {consulta.data.meta.cache} · gerado em{' '}
            {consulta.data.meta.gerado_em}
          </Text>
        </>
      )}
    </Stack>
  );
}
